<template>
	<div class="layer-project" data-project-name="lg-chem-pr-portal">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="nowrap">LG Chem</span> <br /><span class="nowrap"
							>PR Portal</span
						>
					</h1>
				</div>
			</section>
			<!-- <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-01@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-02@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-03@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-04@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-02-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-01@m.jpg"> <img src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-02@t.jpg" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-03-02@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-04@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-05@m.jpg"></section>
        <section><img src="" alt="" data-src="/static/img/project-detail/ket-renewal/ket-renewal-img-06@m.jpg"></section> -->
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<div class="project-overview-tit"><strong>Overview</strong></div>
					<p class="project-overview-desc">
						LG화학의 사내용 파일 공유 시스템을 구축하였습니다.
						<br class="break-t break-w" />
						LG화학의 홍보자료를 한 곳으로 통합하여 보다 편리한 관리가 가능하며
						자료 다운로드 기능을 제공합니다. <br class="break-t break-w" />
						검색 기능과 마이폴더 기능을 통해 빠른 정보 탐색이 가능하고 탐색한
						정보를 관리하는 기능을 추가하였습니다.
						<br class="break-t break-w" />
						자주하는 질문을 분야별로 분류하여 사용자에게 보다 직관적이고 자세한
						정보 전달합니다.
					</p>
					<div class="diagram">
						<ul class="diagram01">
							<li class="item01">Enhanced <br />search <br />capabilities</li>
							<li class="item02">Improved <br />UI/UX Design</li>
							<li class="item03">User <br />convenience</li>
						</ul>
						<ul class="diagram02">
							<li class="item01">LG Chem <br />PR Portal</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section main">
				<div class="inner-section">
					<strong class="project-subtit">PC Web</strong>
					<div class="main-page">
						<div class="img-wrap">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lg-chem-pr-portal/main@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section contents">
				<div class="inner-section">
					<div class="layout">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/contents@m.png"
						/>
					</div>
					<div class="arrow">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/contents-arrow@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section download full">
				<div class="inner-section">
					<div class="layout">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/download@m.jpg"
						/>
					</div>
				</div>
			</section>
			<section class="section contents-bottom full">
				<div class="inner-section">
					<div class="layout">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/contents-bottom@m.jpg"
						/>
					</div>
				</div>
			</section>
			<section class="section style">
				<div class="inner-section">
					<div class="font">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/font-style@m.png"
						/>
					</div>
					<div class="color">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-chem-pr-portal/color-style@m.png"
						/>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">PR Portal</strong>
			</section>
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
.project-tit .nowrap {
	display: inline-block;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-chem-pr-portal/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-client {
		background: url(/static/img/project-detail/lg-chem-pr-portal/ci@m.png) 50% /
			auto 32px no-repeat;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-chem-pr-portal/bg-overview@t.jpg);
	}
	.project-tit .block {
		display: block;
	}
	.project-client {
		background: url(/static/img/project-detail/lg-chem-pr-portal/ci@t.png) 50% /
			auto 28px no-repeat;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-chem-pr-portal/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-client {
		background: url(/static/img/project-detail/lg-chem-pr-portal/ci@w.png) 50% /
			auto 63px no-repeat;
	}
}

/* project-overview */
.project-overview {
	margin-top: 20px;
	background-color: #d32142;
}
.project-overview-tit,
.project-overview-desc {
	color: #fff;
}
.project-overview .diagram {
	margin-top: 20px;
}
.project-overview .diagram01 {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	position: relative;
	width: 269px;
	margin: 0 auto;
	text-align: center;
}
.project-overview .diagram01::before {
	content: "";
	position: absolute;
	bottom: -20px;
	width: 1px;
	height: 41px;
	background-color: #fff;
}
.project-overview .diagram01 > li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	border: 1px solid #fff;
	border-radius: 50%;
	color: #fff;
}
.project-overview .diagram01 .item02 {
	margin-left: -7px;
}
.project-overview .diagram01 .item03 {
	margin-top: -25px;
}
.project-overview .diagram02 {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}
.project-overview .diagram02 > li {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	background-color: #fff;
	border-radius: 50%;
	color: #222;
	text-align: center;
}

@media screen and (min-width: 712px) {
	.project-overview .diagram {
		display: flex;
		width: 633px;
		margin: 36px auto 0;
	}
	.project-overview .diagram01 {
		width: auto;
		margin-top: 0;
		padding-right: 119px;
	}
	.project-overview .diagram01::before {
		content: "";
		position: absolute;
		right: 16px;
		bottom: 50%;
		width: 87px;
		height: 1px;
		justify-content: start;
	}
	.project-overview .diagram01 > li {
		width: 132px;
		height: 132px;
	}
	.project-overview .diagram01 > li + li {
		margin-left: -7px;
	}
	.project-overview .diagram01 .item03 {
		margin-top: 0;
	}
	.project-overview .diagram02 {
		margin-top: 0;
	}
	.project-overview .diagram02 li {
		width: 132px;
		height: 132px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .diagram {
		width: 1240px;
		margin-top: 62px;
		padding-bottom: 20px;
	}
	.project-overview .diagram01 {
		padding-right: 277px;
	}
	.project-overview .diagram01::before {
		right: 62px;
		width: 162px;
	}
	.project-overview .diagram01 > li {
		width: 246px;
		height: 246px;
		font-size: 20px;
	}
	.project-overview .diagram01 > li + li {
		margin-left: -14px;
	}
	.project-overview .diagram01 .item02 {
		margin-left: -14px;
	}
	.project-overview .diagram02 .br-none {
		display: none;
	}
	.project-overview .diagram02 li {
		width: 246px;
		height: 246px;
		font-size: 28px;
	}
}

/* Main */
.main {
	background-color: #baaa93;
}
.main .project-subtit {
	color: #fff;
}
.main .img-wrap {
	margin: 30px auto 0;
	padding-bottom: 25px;
}
.main .img-wrap img {
	width: 100%;
	box-shadow: 37px 33px 60px 0px rgba(0, 0, 0, 0.25);
	border-radius: 20px;
}

@media screen and (min-width: 712px) {
	.main .img-wrap {
		padding-bottom: 80px;
	}
	.main .img-wrap img {
		box-shadow: 52px 47px 80px 0px rgba(0, 0, 0, 0.25);
		border-radius: 24px;
	}
}
@media screen and (min-width: 1280px) {
	.main .project-subtit {
		padding-top: 60px;
	}
	.main .img-wrap {
		padding-bottom: 246px;
	}
	.main .img-wrap img {
		border-radius: 30px;
	}
}

/* Contents */
.contents {
	position: relative;
	padding: 0;
	background-color: #33383e;
}
.contents .layout {
	padding-bottom: 5%;
}
.contents .layout img {
	width: 100%;
	margin-top: -10%;
}
.contents .arrow {
	position: absolute;
	bottom: 15px;
	right: 15px;
	width: 18.75%;
}

@media screen and (min-width: 712px) {
	.contents .arrow {
		bottom: 40px;
		right: 40px;
		width: 11.93820224719101%;
	}
}
@media screen and (min-width: 1280px) {
	.contents .arrow {
		bottom: 65px;
		right: 40px;
		width: 8.85416666666667%;
	}
}

/* Download */
.section.download {
	padding: 0;
}
.download .layout img {
	width: 100%;
}

/* Contents Bottom */
.section.contents-bottom {
	padding: 0;
}
.contents-bottom .layout img {
	width: 100%;
}

/* Style */
.style {
	padding: 40px 15px;
	background-color: #eee;
}
.style .font img {
	width: 199px;
}
.style .color {
	margin-top: 60px;
}
.style .color img {
	width: 100%;
}

@media screen and (min-width: 712px) {
	.style {
		padding: 50px 40px;
	}
	.style .inner-section {
		display: flex;
	}
	.style .inner-section > div {
		width: 50%;
	}
	.style .font img {
		width: 75.63291139240506%;
	}
	.style .color {
		margin-top: 24px;
	}
}
@media screen and (min-width: 1280px) {
	.style {
		padding: 65px 0;
	}
	.style .inner-section {
		padding: 0;
	}
	.style .font img {
		width: 87.03125%;
	}
	.style .color {
		margin-top: 114px;
	}
}

.project-client {
	background-color: #f3f3f3;
}
</style>


// WEBPACK FOOTER //
// src/projects/lg-chem-pr-portal.vue